var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"role":"main"}},[_c('div',{staticClass:"text-center py-5"},[_c('p',{staticClass:"text-secondary"},[_vm._v("Không tìm thấy trang")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Về trang chủ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }